export default "__VITE_ASSET__91qA2GbO__"